const getUserOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'darwin', 'macOS'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

  let os = null;

  if (macosPlatforms.includes(platform)) {
    os = 'Mac OS';
  } else if (iosPlatforms.includes(platform)) {
    os = 'iOS';
  } else if (windowsPlatforms.includes(platform)) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

const getPWADisplayMode = () => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

  if (document.referrer.startsWith('android-app://')) {
    return 'twa';
  } else if (navigator.standalone || isStandalone) {
    return 'standalone';
  }

  return 'browser';
};

export const isRoninBrowser = /Ronin Wallet/i.test(navigator.userAgent);
export const isMetaMaskBrowser = /MetaMask/i.test(navigator.userAgent);

export const displayMode = getPWADisplayMode();
export const os = getUserOS();

export const isBrowser = displayMode === 'browser';
export const isTelegram = window.Telegram?.WebView?.initParams?.tgWebAppData !== undefined;

// for install guide
const hasWrapperBrowser = isTelegram || isRoninBrowser || isMetaMaskBrowser;
export const appCanBeInstalled = isBrowser && !hasWrapperBrowser && ['iOS', 'Android'].includes(os);
